export const api = {
  PRE_REGISTER: 'auth/preRegister',
  REGISTER: 'auth/register',
  LOGIN: 'auth/login',
  REFRESH_TOKEN: 'auth/refreshToken',
  LOGOUT: 'auth/logout',
};
